import LoginIcon from "@mui/icons-material/Login";
import { Button, CircularProgress, Stack, Typography } from "@mui/material";
import React from "react";

import ISsoAuthorizationFormProps from "../../Types/ISsoAuthorizationForm";

export const classNames = {
  spinner: "ssoFormSpinner",
  loginButton: "ssoFormLoginButton",
  errorMessage: "ssoFormErrorMessage"
};

/** A simple form with a single interactive button to initiate an SSO sign-in request. */
const SsoForm: React.FC<ISsoAuthorizationFormProps> = ({ errorMessage, isLoading, label, onClick }) => {
  return (
    <Stack spacing={2} alignItems="center">
      {isLoading ? (
        <CircularProgress className={classNames.spinner} />
      ) : (
        <Button className={classNames.loginButton} onClick={onClick} endIcon={<LoginIcon />}>
          {label || "Login"}
        </Button>
      )}
      {Boolean(errorMessage) && (
        <Typography className={classNames.errorMessage} variant="body1" color="error">
          {errorMessage}
        </Typography>
      )}
    </Stack>
  );
};

export default SsoForm;
